<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title v-if="!temp_id">{{ 'Add Task template' | translate }}</v-card-title>
              <v-card-title v-if="temp_id">{{ 'Edit Task template' | translate}}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form id="form" ref="form">
                    <v-row>
                        <v-col cols="12" sm="8" md="8">
                            <v-row v-if="errors">
                                <v-col cols="12" sm="12" md="12">
                                <v-alert
                                    dense
                                    v-for="(v, k) in errors"
                                    :key="k"
                                    outlined
                                    type="error"
                                >{{ k }} {{ v }}</v-alert>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                    outlined
                                    :label="'Task template name' | translate"
                                    v-model="temp_name"
                                    name="temp_name"
                                    autocomplete="off"
                                    :rules="templatenameRules"
                                    required
                                >
                                <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>                            
                                </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                        outlined
                                        :label="'Validity' | translate"
                                        v-model="temp_validity"
                                        name="temp_validity"
                                        autocomplete="off"
                                        :rules="tempvalidityRules"
                                        type="number"
                                        min='1'
                                        required
                                    >
                                    <template #message="{ message }">
                                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                    </template>                            
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                <v-autocomplete
                                    v-model="validity_type"
                                    :items="validity_types"
                                    item-value="value"
                                    item-text="text"
                                    :label="'Validity type' | translate"
                                    :rules="validitytypeRules"
                                    outlined
                                    chips
                                    small-chips
                                    required
                                    :no-data-text="$t('No data available')"
                                    >
                                    <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                    </template>  
                                    </v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row v-if="temp_id  != null ">
                                <v-col cols="12" sm="6">
                                    <div class="pb-4 title">{{ 'Task templates' | translate}}</div>
                                </v-col>
                                <v-col cols="12" sm="6" style="text-align:right;">
                                    <v-btn small class="white--text" :color="primary_color" @click="openAddEditTemplateBox()" >{{ 'Add document'| translate }}</v-btn>
                                </v-col>
                                <v-divider></v-divider>
                            </v-row>
                            <v-row v-if="temp_id != null ">
                                <v-col cols="12">
                                    <v-data-table
                                    :headers="testcasetemplateheaders"
                                    :search="search"
                                    :items="templateDocuments"
                                    :item-key="temp_id+''+new Date()"
                                    class="elevation-1"
                                    :footer-props="{ 'items-per-page-text': footertext, 'itemsPerPageOptions':[5,10,20,{ text: $t('All'), value: -1 }]   }"
                                    >
                                    <template v-slot:top>
                                    <v-card-title>
                                        <v-spacer></v-spacer>
                                    </v-card-title>
                                    <v-toolbar flat color="white">
                                        <v-spacer></v-spacer>
                                        <v-text-field  v-model="search" append-icon="search" :label="'Search' | translate" single-line hide-details></v-text-field>
                                    </v-toolbar>       
                                    </template> 


                                    <template slot="no-data">
                                        {{ 'No data available' | translate }}
                                    </template>
                                    <template v-slot:footer.page-text="items"> 
                                        {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }} 
                                    </template> 
                                    <template v-slot:item.template ="{ item }" >
                                        <v-icon
                                            small
                                            class="mr-2"
                                            v-on:click="previewTemplate(item.temp_file_id)"
                                        >mdi-eye</v-icon>
                                        <v-icon
                                            small
                                            class="mr-2"
                                            v-if="item.status == 'active'"
                                            v-on:click="openeditTemplateBox(item)"
                                        >edit</v-icon>
                                    </template>
                                    </v-data-table>                          
                                </v-col>
                            </v-row>



                        </v-col>
                        <v-col cols="12" sm="4" md="4">

                        </v-col>
                    </v-row>
                </v-form>
                <v-btn
                dark
                fab
                fixed
                bottom
                right
                large
                color="pink"
                class="mx-2"
                v-if="temp_id == null"
                @click="submit"
                >
                <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-btn
                dark
                fab
                fixed
                bottom
                right
                large
                color="pink"
                class="mx-2"
                v-if="temp_id"
                @click="update"
                >
                <v-icon>mdi-content-save</v-icon>
                </v-btn>
                </v-card-text>
            </v-container>
          </v-card>
       </v-col>
      </v-row>
      <TemplateBox
        v-if="addCertificationDialog"
        :addCertificationDialog="addCertificationDialog"
        @closeTemplateBox="closeTemplateBox"
        @addCustomLabel="addCustomLabel"
        :dragDropValues="dragDropValues"
        :key="addCertificationDialog"
        :temp_id="temp_id"
        :previewSlug="'all-templates/preview'"
        :updateSlug="'templates/test-case'"
        :getData="getData"
        :temp_validity="temp_validity"
        :editSlug="'templates/test-case/view-file/'"
        :editTemplate="editValues"
        :title="templateEditTitle"
       />
    </v-container>
  </v-content>
</template>  
<script>
import {
  ADD_TEST_CASE_TEMPLATE_DATA,
  FETCH_TEST_CASE_TEMPLATE_INDIVIDUAL_DATA,
  DOWNLOAD_TEST_CASE_TEMPLATE,
  UPDATE_TEST_CASE_TEMPLATE_DATA,
  RESET_STATE,
} from "@/store/actions.type";
import {  SET_LOADING, SET_SNACKBAR, SET_ROUTER_ENTER} from "@/store/mutations.type"
import store from "@/store"
import mixins from "@/mixins/mixins"
import { mapState } from "vuex"
import { mapGetters } from "vuex"
export default {
    name: "addeditTestCaseTemplate",   
    mixins: [mixins], 
    async beforeRouteEnter(to, from, next) {
        await store.dispatch(RESET_STATE)
        if (to.params.id) {
        await store.dispatch(FETCH_TEST_CASE_TEMPLATE_INDIVIDUAL_DATA, to.params.id).then(resp => {
        if (resp.success != undefined && resp.success) {
            store.commit(SET_LOADING, false)
            store.commit(SET_ROUTER_ENTER, false)
        }
        });
        }
        return next();
    },
    data: function(){
        return {
            temp_name: null,
            primary_color: null,
            temp_id: null,
            temp_validity: null,
            filename: null,
            validity_types: [
                {value: 'one-time', text:this.$t('One time')},
                {value: 'recurring', text:this.$t('Recurring')}
            ],
            validity_type:null,
            file: null,
            dialog: false,
            search: '',
            editValues: {},
            addCertificationDialog: false,
            editTemplate: false,
            temp_file: null,
            dragDropValues:[],
            templateEditTitle: 'Add template',
            getData: FETCH_TEST_CASE_TEMPLATE_INDIVIDUAL_DATA,
        }
    },
    components : {
        TemplateBox: () => import("@/components/custompdf/custompdf"),
    },
    computed: {
        ...mapGetters(['curLanguage', 'currentUser','individualtestcasetemplate']),
        ...mapState({
        errors: state => state.testcasetemplate.testcasetemplateerrors
        }),
        templateDocuments(){
            return this.individualtestcasetemplate.temp_files
        },
        templatenameRules(){  return [v => !!v || "Template name is required"]},
        tempvalidityRules(){  return [v => !!v || "Validity is required"]},
        templatefileRules(){ 
            return [
                v => !!v || 'Template file is required',
                 
            ]
        },
        testcasetemplateheaders(){
            return [
                { text: this.$t("Status"), value: "status" },  
                { text: this.$t("View"), value: "template" }            ]
        },
        validitytypeRules(){ return [v => !!(v && v.length) || "Validity type is required"]},
        footertext(){
        return this.$t('Rows per page')
        },          
        
    },
    watch:{
        filename(newValue){
            if(newValue == null){
                this.file = null
                this.filename = null
            }
        }
    },
    mounted(){
        if(this.currentUser.roles.includes(1) ==false && this.currentUser.roles.includes(3)== false && JSON.parse(this.currentUser.company.company_meta).has_equip_db == "false"){
        this.$router.push('/dashboard');
        }

        let company_meta  = JSON.parse(this.currentUser.company.company_meta)
        if(Object.keys(this.individualtestcasetemplate).length > 0) {
            this.primary_color  = company_meta.primary_color        
            this.temp_name = this.individualtestcasetemplate.temp_name
            this.temp_id = this.individualtestcasetemplate.temp_id
            this.temp_validity = this.individualtestcasetemplate.temp_validity
            this.validity_type = this.individualtestcasetemplate.validity_type
            this.dragDropValues = JSON.parse(this.individualtestcasetemplate.drag_meta_data)
        }

    },
    methods:{
        async updateDocument(){
            var documentformData = new FormData(document.getElementById("documentform"));
            documentformData.set("temp_name", this.individualtestcasetemplate.temp_name);
            documentformData.set("temp_validity", this.individualtestcasetemplate.temp_validity);
            documentformData.set("temp_id", this.temp_id);
            documentformData.set("_method", "put");
            if (this.file != null) {
                documentformData.append("temp_files", this.file);
            }
            this.$store.dispatch(UPDATE_TEST_CASE_TEMPLATE_DATA, documentformData).then(resp => {
                if (resp.success != undefined && resp.success) {
                    this.$store.dispatch(FETCH_TEST_CASE_TEMPLATE_INDIVIDUAL_DATA, this.individualtestcasetemplate.temp_id).then(resp=>{
                        if(resp.success != undefined && resp.success){
                            this.$store.commit(SET_SNACKBAR, {status: true, message: 'Equipment template updated successfully'})
                            this.file = null
                            this.filename =null
                            this.closeBox();
                        }
                    })
                }
            }); 
        },
        openeditTemplateBox(item) {
            this.editValues = item
            this.templateEditTitle = 'Edit task template'
            this.addCertificationDialog = true
        },
        previewTemplate(id){
            this.handlePreview('all-templates/preview',id)
        },
        openAddEditTemplateBox(){
            this.addCertificationDialog = true
        },
        closeTemplateBox () {
            this.editValues = {}
            this.templateEditTitle = 'Add template'
            this.editTemplate = false
            this.addCertificationDialog = false
        },
        addCustomLabel(item){
            this.dragDropValues = [ ...item ]
            this.editTemplate = true
            this.update()
        },
        updateTaskCenterTemplateDocument(){
            this.dialog = true
        },
        async downloadTemplate(documentdata){
        await this.$store
            .dispatch(DOWNLOAD_TEST_CASE_TEMPLATE, 'view-file/'+documentdata.temp_file_id)
            .then(resp => {
            this.downloadDocument(this.individualtestcasetemplate.temp_name, resp,documentdata)
            this.$store.commit(SET_LOADING, false);
            });
        },
        onFileSelected() {
        this.file = document.getElementById("template_file_id").files[0];
        }, 
        submit(){
            if (this.$refs.form.validate()) {
                var formData = new FormData(document.getElementById("form"));
                if (this.file != null) {
                    formData.append("temp_files", this.file);
                }
                formData.set("validity_type", this.validity_type);
                this.$store.dispatch(ADD_TEST_CASE_TEMPLATE_DATA, formData).then(resp => {
                if (resp.success != undefined && resp.success) {
                    this.$store.commit(SET_SNACKBAR, {status: true, message: 'Task template added successfully'})
                    this.file = null
                    this.filename =null
                    this.$router.push({
                    name: "testcasetemplate",
                    });
                }
                });            
                
            }
        },
        closeBox(){
            this.file = null
            this.filename =null
            document.getElementById("documentform").reset();
            this.dialog = false
        },
        update(){
            if (this.$refs.form.validate()) {
                var formData = new FormData(document.getElementById("form"));
                if (this.file != null) {
                    formData.append("temp_files", this.file);
                }
                formData.set("temp_id", this.temp_id);
                formData.set("validity_type", this.validity_type);
                formData.set("drag_meta_data",JSON.stringify(this.dragDropValues))
                formData.set("_method", "put");

                this.$store.dispatch(UPDATE_TEST_CASE_TEMPLATE_DATA, formData).then(resp => {
                    if (resp.success != undefined && resp.success && !this.editTemplate) {
                        this.$store.commit(SET_SNACKBAR, {status: true, message: 'Task template updated successfully'})
                        this.file = null
                        this.filename =null
                        this.$router.push({
                        name: "testcasetemplate",
                        });
                    }
                    if(this.editTemplate){
                        this.dragDropValues = JSON.parse(resp.data.drag_meta_data)
                        this.$store.dispatch(FETCH_TEST_CASE_TEMPLATE_INDIVIDUAL_DATA, this.temp_id)
                    }
                });            
                
            }
        }
    }
}
</script>
<style lang="scss">
.v-data-footer {
  -webkit-box-pack: start !important;
  -ms-flex-pack: start !important;
  justify-content: flex-start !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}

.v-application--is-ltr .v-data-footer__select {
  margin-left: 16px !important;
}
</style>